module.exports = __webpack_public_path__ + "img/dsci0066.155f12a3.jpg";